__turbopack_context__.v({
  "audience-tag": "FeaturedOfferCard-module-scss-module__tO85Ta__audience-tag",
  "badge": "FeaturedOfferCard-module-scss-module__tO85Ta__badge",
  "badge-container": "FeaturedOfferCard-module-scss-module__tO85Ta__badge-container",
  "container": "FeaturedOfferCard-module-scss-module__tO85Ta__container",
  "content": "FeaturedOfferCard-module-scss-module__tO85Ta__content",
  "content-text": "FeaturedOfferCard-module-scss-module__tO85Ta__content-text",
  "copy-badge": "FeaturedOfferCard-module-scss-module__tO85Ta__copy-badge",
  "cta-container": "FeaturedOfferCard-module-scss-module__tO85Ta__cta-container",
  "description": "FeaturedOfferCard-module-scss-module__tO85Ta__description",
  "image": "FeaturedOfferCard-module-scss-module__tO85Ta__image",
  "image__figure": "FeaturedOfferCard-module-scss-module__tO85Ta__image__figure",
  "modal-text": "FeaturedOfferCard-module-scss-module__tO85Ta__modal-text",
  "see-details-trigger": "FeaturedOfferCard-module-scss-module__tO85Ta__see-details-trigger",
  "title": "FeaturedOfferCard-module-scss-module__tO85Ta__title",
});
